import React from "react";
import {
    Edit,
    TabbedForm,
    FormTab,
    TextInput,
    SelectField,
    DateInput,
    Toolbar,
    SaveButton
} from 'react-admin';
import "../legal_entity/styles/main.css"
import required from "../helper/Required";


const LicenseCreate = props => {
    const Title = props => (
        <div className="title-wrapper">
            <span className="title-text">Редагування лтцензії</span>
        </div>
    );

    const LicenseEditToolbar = props => (
        <Toolbar {...props}>
            <SaveButton />
        </Toolbar>
    );

    return (
        <Edit {...props} title={<Title {...props} />} undoable={false}>
            <TabbedForm validate={required.validateLicenseCreate} toolbar={<LicenseEditToolbar />}>
                <FormTab contentClassName="legal-entities-tab-content" label={<span>Ліцензія <sup>*</sup></span>}>
                    <SelectField formClassName="tab-content-item" label="Тип ліцензії" source="type" validate={required.validateRequired} choices={[
                        { id: 'MSP', name: 'ліцензія на провадження господарської діяльності з медичної практики' },
                        { id: 'PHARMACY', name: 'ліцензія на провадження господарської діяльності з роздрібної торгівлі лікарськими засобами' },
                        { id: 'PHARMACY_DRUGS', name: 'ліцензія на право провадження господарської діяльності з обігу наркотичних засобів, психотропних речовин і прекурсорів' }
                    ]} />
                    <TextInput formClassName="tab-content-item" label="Ким видана" source="issuedBy" validate={required.validateRequired} />
                    <DateInput formClassName="tab-content-item" label="Дата видачі ліцензії" source="issuedDate" validate={required.validateRequired} />
                    <DateInput formClassName="tab-content-item" label="Початок дії ліцензії" source="activeFromDate" validate={required.validateRequired} />
                    <TextInput formClassName="tab-content-item" label="Номер наказу" source="orderNo" validate={required.validateRequired} />
                    <DateInput formClassName="tab-content-item" label="Ліцензія діє до" source="expiryDate" validate={required.validateRequired} />
                    <TextInput formClassName="tab-content-item" label="Серія та номер ліцензії" source="licenseNumber" />
                    <TextInput formClassName="tab-content-item" label="Вид діяльності, що ліцензовано" source="whatLicensed" validate={required.validateRequired} />
                </FormTab>
            </TabbedForm>
        </Edit>
    );
};

export default LicenseCreate;
